import { isMobile } from "react-device-detect"

import apiClient from "../../helpers/apiClient"
import { paymentService } from "../../service/payment"
import { createLoadingSelector } from "./Loading"

export const VERIFY_REDEMPTION_LINK = "VERIFY_REDEMPTION_LINK"
export const VERIFY_REDEMPTION_LINK_REQUEST = "VERIFY_REDEMPTION_LINK_REQUEST"
export const VERIFY_REDEMPTION_LINK_SUCCESS = "VERIFY_REDEMPTION_LINK_SUCCESS"
export const VERIFY_REDEMPTION_LINK_FAILURE = "VERIFY_REDEMPTION_LINK_FAILURE"

export const DECRYPT_LINK = "DECRYPT_LINK"
export const DECRYPT_LINK_REQUEST = "DECRYPT_LINK_REQUEST"
export const DECRYPT_LINK_SUCCESS = "DECRYPT_LINK_SUCCESS"
export const DECRYPT_LINK_FAILURE = "DECRYPT_LINK_FAILURE"

export const SEND_EGIFT_EMAIL = "SEND_EGIFT_EMAIL"
export const SEND_EGIFT_EMAIL_REQUEST = "SEND_EGIFT_EMAIL_REQUEST"
export const SEND_EGIFT_EMAIL_SUCCESS = "SEND_EGIFT_EMAIL_SUCCESS"
export const SEND_EGIFT_EMAIL_FAILURE = "SEND_EGIFT_EMAIL_FAILURE"

export const REMOVE_EGIFT_CARD_INFO = "REMOVE_EGIFT_CARD_INFO"

const initialState = {
	errorMessage: "",
	successMessage: "",
	cardInfo: null,
	cardNo: null,
	name: null,
}

export const decryptLinkSelector = createLoadingSelector([DECRYPT_LINK])
export const decryptLink = (d) => (dispatch, getState) => {
	return dispatch({
		types: [DECRYPT_LINK_REQUEST, DECRYPT_LINK_SUCCESS, DECRYPT_LINK_FAILURE],
		callAPI: (config) => apiClient.post(`api/Egifting/Decrypt`, d, config),
		payload: d,
	})
}

export const verifyingRedemptionSelector = createLoadingSelector([VERIFY_REDEMPTION_LINK])
export const verifyRedemption = (d) => (dispatch, getState) => {
	return dispatch({
		types: [
			VERIFY_REDEMPTION_LINK_REQUEST,
			VERIFY_REDEMPTION_LINK_SUCCESS,
			VERIFY_REDEMPTION_LINK_FAILURE,
		],
		callAPI: async (config) => {
			const res = await apiClient.post(`api/Egifting/Verify`, d, config)

			if (isMobile) {
				const { cardNo, passcode, printedName } = res.data.payload.cardInfo
				const dynamicLink = await paymentService.getEgiftRedemptionDynamicLink(
					cardNo,
					passcode.trim(),
					printedName,
					config
				)
				res.data.payload.cardInfo.redemptionDynamicLink = dynamicLink
					? dynamicLink.link
					: ""
				res.data.payload.cardInfo.redemptionOneAppLink = dynamicLink
					? dynamicLink.oneappLink
					: ""
			}

			return res
		},
		payload: d,
	})
}

export const sendEgiftEmailSelector = createLoadingSelector([SEND_EGIFT_EMAIL])
export const sendEgiftEmail = (d) => (dispatch, getState) => {
	return dispatch({
		types: [
			SEND_EGIFT_EMAIL_REQUEST,
			SEND_EGIFT_EMAIL_SUCCESS,
			SEND_EGIFT_EMAIL_FAILURE,
		],
		callAPI: (config) => apiClient.post(`api/Egifting/EmailEgift`, d, config),
		payload: d,
	})
}

export const removeEgiftCardInfo = () => (dispatch) =>
	dispatch({ type: REMOVE_EGIFT_CARD_INFO })

export default function reducer(state = initialState, action) {
	const { payload, errorMessage, successMessage, error } = action
	switch (action.type) {
		case VERIFY_REDEMPTION_LINK_REQUEST:
			return { ...state, errorMessage: "", successMessage: "" }
		case VERIFY_REDEMPTION_LINK_SUCCESS:
			console.log(action)
			return {
				...state,
				cardInfo: payload.cardInfo,
				name: payload.name,
				successMessage,
			}
		case VERIFY_REDEMPTION_LINK_FAILURE:
			return { ...state, errorMessage }
		case DECRYPT_LINK_REQUEST:
			return { ...state, errorMessage: "", successMessage: "" }
		case DECRYPT_LINK_SUCCESS:
			return { ...state, cardNo: payload.cardNo, successMessage }
		case DECRYPT_LINK_FAILURE:
			return { ...state, errorMessage }
		case SEND_EGIFT_EMAIL_REQUEST:
			return { ...state, errorMessage: "", successMessage: "" }
		case SEND_EGIFT_EMAIL_SUCCESS:
			return { ...state, successMessage }
		case SEND_EGIFT_EMAIL_FAILURE:
			return { ...state, errorMessage }
		case REMOVE_EGIFT_CARD_INFO:
			return { ...state, cardInfo: null }
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/redux/modules/EgiftCardVerifyEgift.js